import React from "react";
import { rowColumn, tableOptions } from "../../../components/table/Table";
import { assignStatusPrimaryOptions, assignStatusSecondaryOptions } from "../../formObjects/application/assignStatusForm";
import { getFilterOptions } from "../../CommonFunctions";

const secondaryOptions = structuredClone(assignStatusSecondaryOptions);
secondaryOptions["Finalised"] = assignStatusSecondaryOptions["Finalised"].filter(
  (x) => x.value === "Outcome sent" || x.value === "KIMS entry complete"
);

export const assessmentsListTable = (currPath: string, assessors: any): rowColumn[] => [
  {
    label: "KIS ID",
    column: "id",
    type: "string",
    allowSort: true,
    sortOn: "Id",
  },
  {
    label: "First Name",
    column: "applicationBase.child.firstName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.FirstName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Last Name",
    column: "applicationBase.child.lastName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Child.LastName",
    isFilter: true,
    filterType: "search",
  },
  {
    label: "Kindergarten",
    column: "applicationBase.kindergarten.fundedKinderName",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.Kindergarten.FundedKinderName",
    body: (rowData) => {
      return (
        <p className="m-0">
          {rowData.applicationBase.kindergarten?.fundedKinderName === "Other"
            ? rowData.applicationBase.kindergarten?.kindergartenNameOther
            : rowData.applicationBase.kindergarten?.fundedKinderName}
        </p>
      );
    },
    isFilter: true,
    filterType: "search",
    filterKeyColumns: ["applicationBase.kindergarten.fundedKinderName", "applicationBase.kindergarten.kindergartenNameOther"],
  },
  {
    label: "Assigned Assessor",
    column: "applicationBase.assignAssessor.assignedAssessor",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignAssessor.AssignedAssessor",
    isFilter: true,
    filterType: "multiselect",
    filterElements: assessors,
  },
  {
    label: "Status",
    column: "applicationBase.assignStatus.statusComputed",
    type: "string",
    allowSort: true,
    sortOn: "ApplicationBase.AssignStatus.StatusComputed",
    isFilter: true,
    filterType: "multiselect",
    filterElements: getFilterOptions(
      assignStatusPrimaryOptions.filter((x) => x.value === "Assessment" || x.value === "QA" || x.value === "Finalised"),
      secondaryOptions
    ),
    globalfilterElements: [
      { label: "Outcome sent", value: "Outcome sent" },
      { label: "KIMS entry complete", value: "KIMS entry complete" },
    ],
  },
  {
    label: "Date Submitted",
    column: "applicationBase.dateSubmitted",
    type: "date",
    allowSort: true,
    sortOn: "ApplicationBase.DateSubmitted",
  },
  {
    label: "KPI",
    column: "applicationBase.kpi",
    type: "number",
    allowSort: true,
    sortOn: "ApplicationBase.KPI",
    body: (rowData) => {
      let kpiStatusColor = "";
      const kpiValue = rowData.applicationBase.kpi;

      if (kpiValue >= 7 && kpiValue <= 10) {
        kpiStatusColor = "kpi-status kpi-green";
      } else if (kpiValue >= 4 && kpiValue <= 6) {
        kpiStatusColor = "kpi-status kpi-yellow";
      } else if (kpiValue >= 1 && kpiValue <= 3) {
        kpiStatusColor = "kpi-status kpi-orange";
      } else if (kpiValue <= 0) {
        kpiStatusColor = "kpi-status kpi-red";
      } else {
        kpiStatusColor = "";
      }
      return (
        <span className={kpiValue != null ? `${kpiStatusColor}` : "kpi-status border-transparent"}>
          {kpiValue != null || kpiValue != undefined ? kpiValue : "—"}
        </span>
      );
    },
  },
  {
    label: "Actions",

    body: (rowData) => <a href={`${currPath}/${rowData.applicationBase.discriminator}/${rowData.id}`}>View Details</a>,
  },
];

export const assessmentsTableOptions: tableOptions = {
  sortField: undefined,
  sortOrder: undefined,
  sortColumn: "ApplicationBase.KPI",
  sortDirection: "asc",
  filters: {
    "applicationBase.assignStatus.statusComputed": {
      searchFilter: [
        "Assessment - Ready for assessment",
        "Assessment - In progress",
        "Assessment - Add Info required",
        "Assessment - Add Info request sent",
        "Assessment - Add Info received",
        "Assessment - Withdrawn",
        "Assessment - Closed - Add Info not received",
        "Assessment - On hold",
        "Assessment - Complete",
        "QA - Ready for QA",
        "QA - Commenced",
        "QA - Assessor attention required",
        "QA - Finalised",
        "Finalised - Outcome sent",
        "Finalised - KIMS entry complete",
      ],
    },
  },
};
